/* Publish by EComposer at 2026-10-14 14:41:15*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-zu0uep8fo4i"]=  window.__ectimmers["ecom-zu0uep8fo4i"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-zu0uep8fo4i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zu0uep8fo4i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8lmnoo0ksl7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8lmnoo0ksl7', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-thvfd1tal5"]=  window.__ectimmers["ecom-thvfd1tal5"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-thvfd1tal5"]["hrk7saj9g"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-thvfd1tal5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-thvfd1tal5', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fygosg1zgse"]=  window.__ectimmers["ecom-fygosg1zgse"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-fygosg1zgse"]["fm3361vdr"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-fygosg1zgse').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fygosg1zgse', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 document.addEventListener("DOMContentLoaded", function () {
  const hostname = window.location.hostname;
  const isStaging = hostname.includes("staging.cellcore.com");

  const bindAddToCartHandlers = (selector, tag) => {
    const elements = document.querySelectorAll(`.${selector}`);
    elements.forEach(element => {
      if (element.dataset.bound) return; // Avoid double-binding
      element.dataset.bound = "true";

      element.addEventListener("click", async () => {
        event.preventDefault();
        const variantId = isStaging
          ? element.getAttribute("data-variant-id-staging")
          : element.getAttribute("data-variant-id-production");

        if (!variantId) {
          return;
        }

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });

          if (!response.ok) throw new Error(`Shopify Error: ${response.statusText}`);

          setTimeout(() => {
            if (typeof openCartDrawer === "function") openCartDrawer();
            if (typeof utils !== "undefined" && utils.cart?.updateCount) {
              utils.cart.updateCount();
            }
          }, 500);
        } catch (error) {
        }
      });
    });
  };

  // Initial bind (in case they’re already rendered)
  bindAddToCartHandlers("add-cart-wholesale", "wholesale");
  bindAddToCartHandlers("add-cart-retail", "retail");

  // MutationObserver to watch for new nodes being added
  const observer = new MutationObserver(mutations => {
    mutations.forEach(() => {
      bindAddToCartHandlers("add-cart-wholesale", "wholesale");
      bindAddToCartHandlers("add-cart-retail", "retail");
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});

} catch(error){console.error(error);}